import { forwardRef } from 'react';
import type { ImgHTMLAttributes, Ref, PropsWithoutRef } from 'react';
import styled from 'styled-components';

import type { ForwardRefForwardPropsComponent } from '../../types';

export interface ImageProps extends ImgHTMLAttributes<HTMLImageElement> {
  /** The HTML alt attribute for the image. */
  alt: string;
  /** Ref for the wrapping element. */
  ref?: Ref<HTMLImageElement>;
}

export const StyledImage = styled.img`
  max-width: 100%;
  height: auto;
`;

const Image: ForwardRefForwardPropsComponent<ImageProps> = forwardRef(function Image(
  props: PropsWithoutRef<ImageProps>,
  ref: ImageProps['ref']
) {
  const { alt, ...restProps } = props;
  return <StyledImage {...restProps} alt={alt} ref={ref} />;
});

export default Image;
